(function ($) {
    $(document).ready(function () {

        var stickyNav = function () {
            var scrollTop = $(window).scrollTop();

            if (scrollTop > 0) {
                $('header').addClass('sticky');
                $('.page-content-head').addClass('sticky');
            } else {
                $('header').removeClass('sticky');
                $('.page-content-head').removeClass('sticky');
            }
        };
        stickyNav();
        $(window).on('scroll', function () {
            stickyNav();
        });

        var $win = $(window);
        var $stat = $('.animatedFadeInUp'); // Change this to affect your desired element.

        $win.on('scroll', function () {
            var scrollTop = $win.scrollTop();

            $stat.each(function () {
                var $self = $(this);
                var prev = $self.offset();
                if ((scrollTop - prev.top) > -700) {
                    $self.addClass('animated fadeInUp ');
                } else {
                }

            });

        }).scroll();

        const mobileMenuBreakPoint = 1400;
        const $subMenuContainer = $('header .submenu-container');
        const $subMenus = $('header .submenu-container .submenu');

        $.fn.openSubmenu = function () {
            const id = $(this).attr('id');
            $(this).addClass('active');
            $subMenuContainer.addClass('active');

            const $subMenu = $subMenuContainer.find('[rel="#' + id + '"]');
            $subMenus.removeClass('active');
            $subMenu.addClass('active');

            if ($(window).width() > mobileMenuBreakPoint) {
                $subMenu.hover(function (e) {
                    $subMenuContainer.addClass('active');
                    $('#' + id).addClass('active');
                }, function (e) {
                    $subMenu.removeClass('active');
                    $subMenuContainer.removeClass('active');
                    $('.main-menu-container .menu-item').removeClass('active');
                    $subMenu.off('mouseenter mouseleave');
                });
            }
        };
        $.fn.closeSubmenu = function () {
            $(this).removeClass('active');
            $subMenuContainer.removeClass('active');
        }

        $('header .main-menu-container .menu-item-has-children').hover(function (e) {
            if ($(window).width() > mobileMenuBreakPoint) {
                $(this).openSubmenu();
            }
        }, function (e) {
            if ($(window).width() > mobileMenuBreakPoint) {
                $(this).closeSubmenu();
            }
        });
        $('header .main-menu-container .menu-item-has-children').on('click', function (e) {
            e.preventDefault();
            if ($(window).width() < mobileMenuBreakPoint) {
                $(this).openSubmenu();
            }
        });
        $('header .submenu-container .mobile-menu-title').on('click', function (e) {
            $('header .main-menu-container .menu-item-has-children').removeClass('active');
            $subMenuContainer.removeClass('active');
            $subMenuContainer.find('.submenu').removeClass('active');
        });

        const $myHampsteadContainer = $('header .my-hampstead-container');
        $('header .my-hampstead').hover(function (e) {
            const id = $(this).attr('id');
            $(this).addClass('active');
            $myHampsteadContainer.addClass('active');
            $myHampsteadContainer.hover(function (e) {
                $myHampsteadContainer.addClass('active');
            }, function (e) {
                $myHampsteadContainer.removeClass('active');
                $('header .my-hampstead').removeClass('active');
                $myHampsteadContainer.off('mouseenter mouseleave');
            });
        }, function (e) {
            $(this).removeClass('active');
            $myHampsteadContainer.removeClass('active');
        });

        $('header .hamburger').on('click', function (e) {
            $(this).toggleClass('is-active');
            $('.main-menu-container').toggleClass('active');
        });

        $('header .search-opener').on('click', function (e) {
            $('.header-search').addClass('opened');
            $('.header-search input').focus();
        });
        $('header .search-closer').on('click', function (e) {
            $('.header-search').removeClass('opened');
        });

        $('.my-hampstead-menu .main-item').on('click', function (e) {
            $('.my-hampstead-menu .main-item').removeClass('active');
            $(this).addClass('active');
            $('.my-hampstead-menu .sub-tiem-container>div').hide();
            $($(this).attr('rel')).show();
        });

        //$(".icon-council-meetings").detach().appendTo(".home-menu-container .menu");

        $('a[href*="#"]:not([href="#"])').click(function (event) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
            }
        });

        if ($.fn.slick && $('.latest-article-slider').length) {
            $('.latest-article-slider').slick({
                centerMode: true,
                infinite: true,
                speed: 500,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 2,
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                    }
                }]
            });
        }

        var alertsClosed = JSON.parse(sessionStorage.getItem('alertsClosed') || '[]');
        $('.single-alert').each(function () {
            if (alertsClosed.indexOf($(this).text()) === -1) {
                $(this).slideDown();
                $('body').addClass('has-alerts');
            }
        });

        $('.single-alert .close').on('click', function () {
            $(this).parents('.single-alert').slideUp();
            alertsClosed.push($(this).parents('.single-alert').text());
            sessionStorage.setItem('alertsClosed', JSON.stringify(alertsClosed));
            $('body').removeClass('has-alerts');
        });

        // Add something to given element placeholder
        function addToPlaceholder(toAdd, el) {
            el.attr('placeholder', el.attr('placeholder') + toAdd);
            // Delay between symbols "typing"
            return new Promise(resolve => setTimeout(resolve, 100));
        }

        // Clear placeholder attribute in given element
        function clearPlaceholder(el) {
            el.attr("placeholder", "");
        }

        // Print one phrase
        function printPhrase(phrase, el, phraseIndex, phrasesLength) {
            return new Promise(resolve => {
                // Clear placeholder before typing next phrase
                clearPlaceholder(el);
                let letters = phrase.split('');
                // For each letter in phrase
                letters.reduce(
                    (promise, letter, index) => promise.then(_ => {
                        // Resolve promise when all letters are typed
                        if (index === letters.length - 1) {
                            // Delay before start next phrase "typing"
                            setTimeout(resolve, 1000);
                        }
                        // if the array has been completely scanned and the animation is complete
                        // restart the function
                        if (phraseIndex === phrasesLength - 1 && index === letters.length - 1) {
                            setTimeout(run, 1000);
                        }

                        return addToPlaceholder(letter, el);
                    }),
                    Promise.resolve()
                );
            });
        }

        // Print given phrases to element
        function printPhrases(phrases, el) {
            // For each phrase
            // wait for phrase to be typed
            // before start typing next
            phrases.reduce(
                (promise, phrase) => promise.then(_ => printPhrase(phrase, el, phrases.indexOf(phrase), phrases.length)),
                Promise.resolve()
            );
        }

        // Start typing
        function run() {
            if ($('#dom-target').length) {
                let searchField = JSON.parse(decodeURIComponent($('#dom-target').val()));
                let phrases = [];
                searchField.forEach(phrase =>
                    phrases.push(phrase.textes)
                );
                printPhrases(phrases, $('.searchbar'));
            }
        }

        run();

        // Show form input based on radio value
        $('#form-field-message').slideUp();
        $('#form-field-satisfaction_radio-1, #form-field-satisfaction_radio-0').on('change', function () {
            if (this.value === 'non') {
                $('#form-field-message').slideDown();
            } else {
                $('#form-field-message').slideUp();
            }
        });

        // remove wp-embed footer
        if ($(".wp-embed-footer").length) {
            $(".wp-embed-footer").css('display', 'none');
        }

        // add z-index on is-overflown hover - png calendar
        $('.is-overflown').on('mouseenter mouseleave', function () {
            $(this).toggleClass('hovered');
        });
        $('.png-calendar').on('mouseenter mouseleave', '.is-overflown', function () {
            $(this).toggleClass('hovered');
        });
    });
})(jQuery);

var getUrlParameter = function (sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

var xhrPostsApi;
var postsApi = function (options, callback) {
    if (xhrPostsApi) {
        xhrPostsApi.abort();
        xhrPostsApi = null;
    }

    xhrPostsApi = $.ajax({
        'url': '/wp-json/penega/v1/posts',
        'method': 'GET',
        'data': options
    }).done(function (data) {
        callback(data);
    });
};
var xhrByLawApi;
var bylawApi = function (options, callback) {
    if (xhrByLawApi) {
        xhrByLawApi.abort();
        xhrByLawApi = null;
    }

    xhrByLawApi = $.ajax({
        'url': '/wp-json/penega/v1/bylaws',
        'method': 'GET',
        'data': options
    }).done(function (data) {
        callback(data);
    });
};

var xhrAvisApi;
var avisApi = function (options, callback) {
    if (xhrAvisApi) {
        xhrAvisApi.abort();
        xhrAvisApi = null;
    }

    xhrAvisApi = $.ajax({
        'url': '/wp-json/penega/v1/avis',
        'method': 'GET',
        'data': options
    }).done(function (data) {
        callback(data);
    });
};

